import './shortcode'


if (SSB.is_pro) {
  require('./click-to-tweet');
}


// WEBPACK FOOTER //
// blocks/index.js